import Menu from 'components/Menu'
import RoundyContainer from 'components/RoundyContainer'
import BlockMain from 'components/StraightThroughVehicleComp/VehicleMain_Add/BlockMain'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { storageData } from 'services/Services'
import { ReplaceVehicleContextComp } from 'components/StraightThroughVehicleComp/ReplaceVehicleContext/ReplaceVehicleContext'

const ReplaceVehicleEndorsementBlock = (props) => {
    const navigate = useNavigate();
    const { userData } = props.user
    const websiteMaintenance = JSON.parse(storageData?.getItem("websiteMaintenance"));

    useEffect(() => {
        window.scrollTo(0, 0)

        // Redirect to maintenance page if maintenance is on for Add Vehicle Endorsement
        if (websiteMaintenance?.status?.Result == "Active" && websiteMaintenance?.status?.Pages?.includes("EndorsementReplaceVehicle")) {
            navigate("/maintenance")
            return
        }
    }, [])

    return (
        <>
            <ReplaceVehicleContextComp>
                <Menu Title={"REPLACE VEHICLE"} FirstName={userData.firstName} userData={userData} />
                <RoundyContainer Content={BlockMain} NoRoundy
                    params={{
                        storedData: { ...props.storedData },
                        setStoredData: props.setStoredData
                    }}
                />
            </ReplaceVehicleContextComp>
        </>
    )
}

export default ReplaceVehicleEndorsementBlock